import type React from 'react'
import { Button, type ButtonProps } from '@components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@components/ui/tooltip'

export interface TooltipIconButtonProps extends ButtonProps {
  tooltip: React.ReactNode
}

/** Outline icon button with a top tooltip; the span keeps the tooltip working while disabled. */
export function TooltipIconButton({ tooltip, children, ...buttonProps }: TooltipIconButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <Button type="button" variant="outline" size="icon" {...buttonProps}>
            {children}
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">{tooltip}</TooltipContent>
    </Tooltip>
  )
}
